import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20l16 0","key":"svg-0"}],["path",{"d":"M9 6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2l0 -8","key":"svg-1"}]]

const IconLayoutAlignBottom = createReactComponent('outline', 'layout-align-bottom', 'LayoutAlignBottom', __iconNode);

export default IconLayoutAlignBottom;